import { getCurrentScope as Nt, onScopeDispose as Pt, unref as _, onMounted as te, nextTick as $e, getCurrentInstance as pe, watch as $, ref as m, computed as k, watchEffect as nn, inject as Bt, defineComponent as V, useCssVars as ve, openBlock as I, createElementBlock as ee, withModifiers as Ht, normalizeClass as zt, createBlock as ce, h as Re, readonly as on, reactive as Ie, renderSlot as me, provide as Dt, useTemplateRef as Ne, createVNode as J, Transition as rn, withCtx as de, mergeProps as an, createElementVNode as sn, createCommentVNode as ln, useSlots as un, useAttrs as cn, onBeforeUnmount as dn, defineAsyncComponent as _e, resolveDynamicComponent as fn } from "vue";
const hn = (e, t, n) => {
  const o = e[t];
  return o ? typeof o == "function" ? o() : Promise.resolve(o) : new Promise((i, r) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      r.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + t + (t.split("/").length !== n ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
function be(e) {
  return Nt() ? (Pt(e), !0) : !1;
}
function ne(e) {
  return typeof e == "function" ? e() : _(e);
}
const Vt = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const gn = (e) => e != null, pn = Object.prototype.toString, vn = (e) => pn.call(e) === "[object Object]", ue = () => {
}, mn = /* @__PURE__ */ bn();
function bn() {
  var e, t;
  return Vt && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function yn(e) {
  return pe();
}
function Le(e, t = !0, n) {
  yn() ? te(e, n) : t ? e() : $e(e);
}
function A(e) {
  var t;
  const n = ne(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const P = Vt ? window : void 0;
function O(...e) {
  let t, n, o, i;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, o, i] = e, t = P) : [t, n, o, i] = e, !t)
    return ue;
  Array.isArray(n) || (n = [n]), Array.isArray(o) || (o = [o]);
  const r = [], a = () => {
    r.forEach((c) => c()), r.length = 0;
  }, s = (c, u, d, h) => (c.addEventListener(u, d, h), () => c.removeEventListener(u, d, h)), l = $(
    () => [A(t), ne(i)],
    ([c, u]) => {
      if (a(), !c)
        return;
      const d = vn(u) ? { ...u } : u;
      r.push(
        ...n.flatMap((h) => o.map((p) => s(c, h, p, d)))
      );
    },
    { immediate: !0, flush: "post" }
  ), f = () => {
    l(), a();
  };
  return be(f), f;
}
let Pe = !1;
function wn(e, t, n = {}) {
  const { window: o = P, ignore: i = [], capture: r = !0, detectIframe: a = !1 } = n;
  if (!o)
    return ue;
  mn && !Pe && (Pe = !0, Array.from(o.document.body.children).forEach((d) => d.addEventListener("click", ue)), o.document.documentElement.addEventListener("click", ue));
  let s = !0;
  const l = (d) => i.some((h) => {
    if (typeof h == "string")
      return Array.from(o.document.querySelectorAll(h)).some((p) => p === d.target || d.composedPath().includes(p));
    {
      const p = A(h);
      return p && (d.target === p || d.composedPath().includes(p));
    }
  }), c = [
    O(o, "click", (d) => {
      const h = A(e);
      if (!(!h || h === d.target || d.composedPath().includes(h))) {
        if (d.detail === 0 && (s = !l(d)), !s) {
          s = !0;
          return;
        }
        t(d);
      }
    }, { passive: !0, capture: r }),
    O(o, "pointerdown", (d) => {
      const h = A(e);
      s = !l(d) && !!(h && !d.composedPath().includes(h));
    }, { passive: !0 }),
    a && O(o, "blur", (d) => {
      setTimeout(() => {
        var h;
        const p = A(e);
        ((h = o.document.activeElement) == null ? void 0 : h.tagName) === "IFRAME" && !(p != null && p.contains(o.document.activeElement)) && t(d);
      }, 0);
    })
  ].filter(Boolean);
  return () => c.forEach((d) => d());
}
function _n(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function Or(...e) {
  let t, n, o = {};
  e.length === 3 ? (t = e[0], n = e[1], o = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], o = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
  const {
    target: i = P,
    eventName: r = "keydown",
    passive: a = !1,
    dedupe: s = !1
  } = o, l = _n(t);
  return O(i, r, (c) => {
    c.repeat && ne(s) || l(c) && n(c);
  }, a);
}
function Sn() {
  const e = m(!1), t = pe();
  return t && te(() => {
    e.value = !0;
  }, t), e;
}
function Te(e) {
  const t = Sn();
  return k(() => (t.value, !!e()));
}
function kn(e, t, n = {}) {
  const { window: o = P, ...i } = n;
  let r;
  const a = Te(() => o && "MutationObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, l = k(() => {
    const d = ne(e), h = (Array.isArray(d) ? d : [d]).map(A).filter(gn);
    return new Set(h);
  }), f = $(
    () => l.value,
    (d) => {
      s(), a.value && d.size && (r = new MutationObserver(t), d.forEach((h) => r.observe(h, i)));
    },
    { immediate: !0, flush: "post" }
  ), c = () => r == null ? void 0 : r.takeRecords(), u = () => {
    s(), f();
  };
  return be(u), {
    isSupported: a,
    stop: u,
    takeRecords: c
  };
}
function xn(e, t = {}) {
  const { window: n = P } = t, o = Te(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let i;
  const r = m(!1), a = (f) => {
    r.value = f.matches;
  }, s = () => {
    i && ("removeEventListener" in i ? i.removeEventListener("change", a) : i.removeListener(a));
  }, l = nn(() => {
    o.value && (s(), i = n.matchMedia(ne(e)), "addEventListener" in i ? i.addEventListener("change", a) : i.addListener(a), r.value = i.matches);
  });
  return be(() => {
    l(), s(), i = void 0;
  }), r;
}
function Wt(e, t, n = {}) {
  const { window: o = P, ...i } = n;
  let r;
  const a = Te(() => o && "ResizeObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, l = k(() => Array.isArray(e) ? e.map((u) => A(u)) : [A(e)]), f = $(
    l,
    (u) => {
      if (s(), a.value && o) {
        r = new ResizeObserver(t);
        for (const d of u)
          d && r.observe(d, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    s(), f();
  };
  return be(c), {
    isSupported: a,
    stop: c
  };
}
function Er(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: o = !0,
    windowScroll: i = !0,
    immediate: r = !0
  } = t, a = m(0), s = m(0), l = m(0), f = m(0), c = m(0), u = m(0), d = m(0), h = m(0);
  function p() {
    const b = A(e);
    if (!b) {
      n && (a.value = 0, s.value = 0, l.value = 0, f.value = 0, c.value = 0, u.value = 0, d.value = 0, h.value = 0);
      return;
    }
    const y = b.getBoundingClientRect();
    a.value = y.height, s.value = y.bottom, l.value = y.left, f.value = y.right, c.value = y.top, u.value = y.width, d.value = y.x, h.value = y.y;
  }
  return Wt(e, p), $(() => A(e), (b) => !b && p()), kn(e, p, {
    attributeFilter: ["style", "class"]
  }), i && O("scroll", p, { capture: !0, passive: !0 }), o && O("resize", p, { passive: !0 }), Le(() => {
    r && p();
  }), {
    height: a,
    bottom: s,
    left: l,
    right: f,
    top: c,
    width: u,
    x: d,
    y: h,
    update: p
  };
}
function Fr(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: o = P, box: i = "content-box" } = n, r = k(() => {
    var u, d;
    return (d = (u = A(e)) == null ? void 0 : u.namespaceURI) == null ? void 0 : d.includes("svg");
  }), a = m(t.width), s = m(t.height), { stop: l } = Wt(
    e,
    ([u]) => {
      const d = i === "border-box" ? u.borderBoxSize : i === "content-box" ? u.contentBoxSize : u.devicePixelContentBoxSize;
      if (o && r.value) {
        const h = A(e);
        if (h) {
          const p = h.getBoundingClientRect();
          a.value = p.width, s.value = p.height;
        }
      } else if (d) {
        const h = Array.isArray(d) ? d : [d];
        a.value = h.reduce((p, { inlineSize: b }) => p + b, 0), s.value = h.reduce((p, { blockSize: b }) => p + b, 0);
      } else
        a.value = u.contentRect.width, s.value = u.contentRect.height;
    },
    n
  );
  Le(() => {
    const u = A(e);
    u && (a.value = "offsetWidth" in u ? u.offsetWidth : t.width, s.value = "offsetHeight" in u ? u.offsetHeight : t.height);
  });
  const f = $(
    () => A(e),
    (u) => {
      a.value = u ? t.width : 0, s.value = u ? t.height : 0;
    }
  );
  function c() {
    l(), f();
  }
  return {
    width: a,
    height: s,
    stop: c
  };
}
function Ir(e, t = {}) {
  const { initialValue: n = !1, focusVisible: o = !1, preventScroll: i = !1 } = t, r = m(!1), a = k(() => A(e));
  O(a, "focus", (l) => {
    var f, c;
    (!o || (c = (f = l.target).matches) != null && c.call(f, ":focus-visible")) && (r.value = !0);
  }), O(a, "blur", () => r.value = !1);
  const s = k({
    get: () => r.value,
    set(l) {
      var f, c;
      !l && r.value ? (f = a.value) == null || f.blur() : l && !r.value && ((c = a.value) == null || c.focus({ preventScroll: i }));
    }
  });
  return $(
    a,
    () => {
      s.value = n;
    },
    { immediate: !0, flush: "post" }
  ), { focused: s };
}
function Nr(e = {}) {
  const {
    window: t = P,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: o = Number.POSITIVE_INFINITY,
    listenOrientation: i = !0,
    includeScrollbar: r = !0
  } = e, a = m(n), s = m(o), l = () => {
    t && (r ? (a.value = t.innerWidth, s.value = t.innerHeight) : (a.value = t.document.documentElement.clientWidth, s.value = t.document.documentElement.clientHeight));
  };
  if (l(), Le(l), O("resize", l, { passive: !0 }), i) {
    const f = xn("(orientation: portrait)");
    $(f, () => l());
  }
  return { width: a, height: s };
}
const Ut = Symbol("theme"), An = {
  mainColor: {
    base: "#333333",
    over: "#2CB0B8",
    contrasted: "#FFFFFF"
  },
  fontColor: "#333333",
  actionColor: {
    base: "#32BFC8",
    washed: "rgba(51, 51, 51, 0.24)",
    over: "#2CB0B8",
    contrasted: "#FFFFFF"
  },
  actionContrastColor: {
    base: "#FFFFFF",
    over: "#333333",
    contrasted: "#333333"
  },
  backgroundColor: {
    base: "#FFFFFF",
    over: "#2CB0B8",
    washed: "rgba(51, 51, 51, 0.24)",
    dimmed: "rgba(51, 51, 51, 0.24)",
    contrasted: "#333333"
  },
  backgroundHighlight: !0,
  border: !1,
  borderColor: "#333333",
  borderRadius: "8px"
}, je = () => Bt(Ut, An);
function xe(e, t) {
  return t ? Object.keys(t).reduce(
    (n, o) => n.replace(`{${o}}`, t[o].toString()),
    e
  ) : e;
}
const qt = Symbol("i18n"), Gt = () => Bt(qt, {
  t: (e, t) => xe(e, t) || e,
  tc: (e, t, n) => xe(e, n) || e
}), Oe = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
};
function Ae(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Cn = typeof global == "object" && global && global.Object === Object && global, Mn = typeof self == "object" && self && self.Object === Object && self, Kt = Cn || Mn || Function("return this")(), Se = function() {
  return Kt.Date.now();
}, $n = /\s/;
function Rn(e) {
  for (var t = e.length; t-- && $n.test(e.charAt(t)); )
    ;
  return t;
}
var Ln = /^\s+/;
function Tn(e) {
  return e && e.slice(0, Rn(e) + 1).replace(Ln, "");
}
var fe = Kt.Symbol, Qt = Object.prototype, jn = Qt.hasOwnProperty, On = Qt.toString, G = fe ? fe.toStringTag : void 0;
function En(e) {
  var t = jn.call(e, G), n = e[G];
  try {
    e[G] = void 0;
    var o = !0;
  } catch {
  }
  var i = On.call(e);
  return o && (t ? e[G] = n : delete e[G]), i;
}
var Fn = Object.prototype, In = Fn.toString;
function Nn(e) {
  return In.call(e);
}
var Pn = "[object Null]", Bn = "[object Undefined]", Be = fe ? fe.toStringTag : void 0;
function Hn(e) {
  return e == null ? e === void 0 ? Bn : Pn : Be && Be in Object(e) ? En(e) : Nn(e);
}
function zn(e) {
  return e != null && typeof e == "object";
}
var Dn = "[object Symbol]";
function Vn(e) {
  return typeof e == "symbol" || zn(e) && Hn(e) == Dn;
}
var He = NaN, Wn = /^[-+]0x[0-9a-f]+$/i, Un = /^0b[01]+$/i, qn = /^0o[0-7]+$/i, Gn = parseInt;
function ze(e) {
  if (typeof e == "number")
    return e;
  if (Vn(e))
    return He;
  if (Ae(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Ae(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Tn(e);
  var n = Un.test(e);
  return n || qn.test(e) ? Gn(e.slice(2), n ? 2 : 8) : Wn.test(e) ? He : +e;
}
var Kn = "Expected a function", Qn = Math.max, Yn = Math.min;
function Xn(e, t, n) {
  var o, i, r, a, s, l, f = 0, c = !1, u = !1, d = !0;
  if (typeof e != "function")
    throw new TypeError(Kn);
  t = ze(t) || 0, Ae(n) && (c = !!n.leading, u = "maxWait" in n, r = u ? Qn(ze(n.maxWait) || 0, t) : r, d = "trailing" in n ? !!n.trailing : d);
  function h(x) {
    var j = o, w = i;
    return o = i = void 0, f = x, a = e.apply(w, j), a;
  }
  function p(x) {
    return f = x, s = setTimeout(B, t), c ? h(x) : a;
  }
  function b(x) {
    var j = x - l, w = x - f, R = t - j;
    return u ? Yn(R, r - w) : R;
  }
  function y(x) {
    var j = x - l, w = x - f;
    return l === void 0 || j >= t || j < 0 || u && w >= r;
  }
  function B() {
    var x = Se();
    if (y(x))
      return ie(x);
    s = setTimeout(B, b(x));
  }
  function ie(x) {
    return s = void 0, d && o ? h(x) : (o = i = void 0, a);
  }
  function ae() {
    s !== void 0 && clearTimeout(s), f = 0, o = l = i = s = void 0;
  }
  function E() {
    return s === void 0 ? a : ie(Se());
  }
  function H() {
    var x = Se(), j = y(x);
    if (o = arguments, i = this, l = x, j) {
      if (s === void 0)
        return p(l);
      if (u)
        return clearTimeout(s), s = setTimeout(B, t), h(l);
    }
    return s === void 0 && (s = setTimeout(B, t)), a;
  }
  return H.cancel = ae, H.flush = E, H;
}
const Zn = (e, t) => {
  const n = "http://www.w3.org/2000/svg", o = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M13.03 4.47a.75.75 0 010 1.06L8.56 10l4.47 4.47a.75.75 0 11-1.06 1.06l-5-5a.75.75 0 010-1.06l5-5a.75.75 0 011.06 0z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const r = document.createElementNS(n, "title");
    r.textContent = e.title, o.appendChild(r);
  }
  const i = Array.from((o == null ? void 0 : o.attributes) ?? []).reduce((r, a) => ({
    ...r,
    [a.name]: a.value
  }));
  return Re(
    "svg",
    {
      ...i,
      ...t.attrs,
      role: "img",
      innerHTML: o.innerHTML
    }
  );
}, Jn = (e, t) => {
  const n = "http://www.w3.org/2000/svg", o = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.47 4.47a.75.75 0 011.06 0L10 8.94l4.47-4.47a.75.75 0 111.06 1.06L11.06 10l4.47 4.47a.75.75 0 11-1.06 1.06L10 11.06l-4.47 4.47a.75.75 0 01-1.06-1.06L8.94 10 4.47 5.53a.75.75 0 010-1.06z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const r = document.createElementNS(n, "title");
    r.textContent = e.title, o.appendChild(r);
  }
  const i = Array.from((o == null ? void 0 : o.attributes) ?? []).reduce((r, a) => ({
    ...r,
    [a.name]: a.value
  }));
  return Re(
    "svg",
    {
      ...i,
      ...t.attrs,
      role: "img",
      innerHTML: o.innerHTML
    }
  );
}, eo = ["aria-label"], to = /* @__PURE__ */ V({
  __name: "ActionButton",
  props: {
    type: { default: "close" },
    color: {},
    overColor: {},
    size: { default: "medium" }
  },
  emits: ["action-click"],
  setup(e, { emit: t }) {
    ve((f) => ({
      "5be0768a": a.value,
      "61a71047": s.value,
      "908a0cea": _(i).borderRadius
    }));
    const n = e, o = t, i = je(), { t: r } = Gt(), a = k(() => n.color ?? "#333"), s = k(() => n.overColor ?? i.actionColor.base), l = Xn(() => {
      o("action-click");
    }, 200, { leading: !0, trailing: !1 });
    return (f, c) => (I(), ee("button", {
      type: "button",
      onMousedown: c[0] || (c[0] = Ht(
        //@ts-ignore
        (...u) => _(l) && _(l)(...u),
        ["left"]
      )),
      onClick: c[1] || (c[1] = //@ts-ignore
      (...u) => _(l) && _(l)(...u)),
      "data-testid": "action-trigger",
      "aria-label": n.type === "close" ? _(r)("Close") : _(r)("Back"),
      class: zt(["actionTrigger", `actionTrigger--${n.size}`])
    }, [
      f.type === "close" ? (I(), ce(_(Jn), {
        key: 0,
        "aria-label": _(r)("Close"),
        class: "actionTrigger__icon close"
      }, null, 8, ["aria-label"])) : (I(), ce(_(Zn), {
        key: 1,
        "aria-label": _(r)("Back"),
        class: "actionTrigger__icon back"
      }, null, 8, ["aria-label"]))
    ], 42, eo));
  }
}), no = /* @__PURE__ */ Oe(to, [["__scopeId", "data-v-69dca2dc"]]);
function ye(e) {
  return Nt() ? (Pt(e), !0) : !1;
}
function oe(e) {
  return typeof e == "function" ? e() : _(e);
}
const Yt = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const oo = (e) => e != null, ro = Object.prototype.toString, io = (e) => ro.call(e) === "[object Object]", Ce = () => {
};
function ao(e) {
  return pe();
}
function so(e, t = !0, n) {
  ao() ? te(e, n) : t ? e() : $e(e);
}
function Pr(e, t, n = {}) {
  const {
    immediate: o = !0
  } = n, i = m(!1);
  let r = null;
  function a() {
    r && (clearTimeout(r), r = null);
  }
  function s() {
    i.value = !1, a();
  }
  function l(...f) {
    a(), i.value = !0, r = setTimeout(() => {
      i.value = !1, r = null, e(...f);
    }, oe(t));
  }
  return o && (i.value = !0, Yt && l()), ye(s), {
    isPending: on(i),
    start: l,
    stop: s
  };
}
function q(e) {
  var t;
  const n = oe(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const re = Yt ? window : void 0;
function U(...e) {
  let t, n, o, i;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, o, i] = e, t = re) : [t, n, o, i] = e, !t)
    return Ce;
  Array.isArray(n) || (n = [n]), Array.isArray(o) || (o = [o]);
  const r = [], a = () => {
    r.forEach((c) => c()), r.length = 0;
  }, s = (c, u, d, h) => (c.addEventListener(u, d, h), () => c.removeEventListener(u, d, h)), l = $(
    () => [q(t), oe(i)],
    ([c, u]) => {
      if (a(), !c)
        return;
      const d = io(u) ? { ...u } : u;
      r.push(
        ...n.flatMap((h) => o.map((p) => s(c, h, p, d)))
      );
    },
    { immediate: !0, flush: "post" }
  ), f = () => {
    l(), a();
  };
  return ye(f), f;
}
function lo(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function De(...e) {
  let t, n, o = {};
  e.length === 3 ? (t = e[0], n = e[1], o = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], o = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
  const {
    target: i = re,
    eventName: r = "keydown",
    passive: a = !1,
    dedupe: s = !1
  } = o, l = lo(t);
  return U(i, r, (f) => {
    f.repeat && oe(s) || l(f) && n(f);
  }, a);
}
function uo() {
  const e = m(!1), t = pe();
  return t && te(() => {
    e.value = !0;
  }, t), e;
}
function Xt(e) {
  const t = uo();
  return k(() => (t.value, !!e()));
}
function co(e, t, n = {}) {
  const { window: o = re, ...i } = n;
  let r;
  const a = Xt(() => o && "MutationObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, l = k(() => {
    const d = oe(e), h = (Array.isArray(d) ? d : [d]).map(q).filter(oo);
    return new Set(h);
  }), f = $(
    () => l.value,
    (d) => {
      s(), a.value && d.size && (r = new MutationObserver(t), d.forEach((h) => r.observe(h, i)));
    },
    { immediate: !0, flush: "post" }
  ), c = () => r == null ? void 0 : r.takeRecords(), u = () => {
    s(), f();
  };
  return ye(u), {
    isSupported: a,
    stop: u,
    takeRecords: c
  };
}
function fo(e, t, n = {}) {
  const { window: o = re, ...i } = n;
  let r;
  const a = Xt(() => o && "ResizeObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, l = k(() => Array.isArray(e) ? e.map((u) => q(u)) : [q(e)]), f = $(
    l,
    (u) => {
      if (s(), a.value && o) {
        r = new ResizeObserver(t);
        for (const d of u)
          d && r.observe(d, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    s(), f();
  };
  return ye(c), {
    isSupported: a,
    stop: c
  };
}
function Br(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: o = !0,
    windowScroll: i = !0,
    immediate: r = !0
  } = t, a = m(0), s = m(0), l = m(0), f = m(0), c = m(0), u = m(0), d = m(0), h = m(0);
  function p() {
    const b = q(e);
    if (!b) {
      n && (a.value = 0, s.value = 0, l.value = 0, f.value = 0, c.value = 0, u.value = 0, d.value = 0, h.value = 0);
      return;
    }
    const y = b.getBoundingClientRect();
    a.value = y.height, s.value = y.bottom, l.value = y.left, f.value = y.right, c.value = y.top, u.value = y.width, d.value = y.x, h.value = y.y;
  }
  return fo(e, p), $(() => q(e), (b) => !b && p()), co(e, p, {
    attributeFilter: ["style", "class"]
  }), i && U("scroll", p, { capture: !0, passive: !0 }), o && U("resize", p, { passive: !0 }), so(() => {
    r && p();
  }), {
    height: a,
    bottom: s,
    left: l,
    right: f,
    top: c,
    width: u,
    x: d,
    y: h,
    update: p
  };
}
function ho(e, t = {}) {
  const {
    threshold: n = 50,
    onSwipe: o,
    onSwipeEnd: i,
    onSwipeStart: r,
    passive: a = !0,
    window: s = re
  } = t, l = Ie({ x: 0, y: 0 }), f = Ie({ x: 0, y: 0 }), c = k(() => l.x - f.x), u = k(() => l.y - f.y), { max: d, abs: h } = Math, p = k(() => d(h(c.value), h(u.value)) >= n), b = m(!1), y = k(() => p.value ? h(c.value) > h(u.value) ? c.value > 0 ? "left" : "right" : u.value > 0 ? "up" : "down" : "none"), B = (w) => [w.touches[0].clientX, w.touches[0].clientY], ie = (w, R) => {
    l.x = w, l.y = R;
  }, ae = (w, R) => {
    f.x = w, f.y = R;
  };
  let E;
  const H = go(s == null ? void 0 : s.document);
  a ? E = H ? { passive: !0 } : { capture: !1 } : E = H ? { passive: !1, capture: !0 } : { capture: !0 };
  const x = (w) => {
    b.value && (i == null || i(w, y.value)), b.value = !1;
  }, j = [
    U(e, "touchstart", (w) => {
      if (w.touches.length !== 1)
        return;
      E.capture && !E.passive && w.preventDefault();
      const [R, se] = B(w);
      ie(R, se), ae(R, se), r == null || r(w);
    }, E),
    U(e, "touchmove", (w) => {
      if (w.touches.length !== 1)
        return;
      const [R, se] = B(w);
      ae(R, se), !b.value && p.value && (b.value = !0), b.value && (o == null || o(w));
    }, E),
    U(e, ["touchend", "touchcancel"], x, E)
  ];
  return {
    isPassiveEventSupported: H,
    isSwiping: b,
    direction: y,
    coordsStart: l,
    coordsEnd: f,
    lengthX: c,
    lengthY: u,
    stop: () => j.forEach((w) => w())
  };
}
function go(e) {
  if (!e)
    return !1;
  let t = !1;
  const n = {
    get passive() {
      return t = !0, !1;
    }
  };
  return e.addEventListener("x", Ce, n), e.removeEventListener("x", Ce), t;
}
function he(e) {
  "@babel/helpers - typeof";
  return he = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, he(e);
}
var po = /^\s+/, vo = /\s+$/;
function g(e, t) {
  if (e = e || "", t = t || {}, e instanceof g)
    return e;
  if (!(this instanceof g))
    return new g(e, t);
  var n = mo(e);
  this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
g.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var e = this.toRgb();
    return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
  },
  getLuminance: function() {
    var e = this.toRgb(), t, n, o, i, r, a;
    return t = e.r / 255, n = e.g / 255, o = e.b / 255, t <= 0.03928 ? i = t / 12.92 : i = Math.pow((t + 0.055) / 1.055, 2.4), n <= 0.03928 ? r = n / 12.92 : r = Math.pow((n + 0.055) / 1.055, 2.4), o <= 0.03928 ? a = o / 12.92 : a = Math.pow((o + 0.055) / 1.055, 2.4), 0.2126 * i + 0.7152 * r + 0.0722 * a;
  },
  setAlpha: function(e) {
    return this._a = Zt(e), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var e = We(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      v: e.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var e = We(this._r, this._g, this._b), t = Math.round(e.h * 360), n = Math.round(e.s * 100), o = Math.round(e.v * 100);
    return this._a == 1 ? "hsv(" + t + ", " + n + "%, " + o + "%)" : "hsva(" + t + ", " + n + "%, " + o + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var e = Ve(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      l: e.l,
      a: this._a
    };
  },
  toHslString: function() {
    var e = Ve(this._r, this._g, this._b), t = Math.round(e.h * 360), n = Math.round(e.s * 100), o = Math.round(e.l * 100);
    return this._a == 1 ? "hsl(" + t + ", " + n + "%, " + o + "%)" : "hsla(" + t + ", " + n + "%, " + o + "%, " + this._roundA + ")";
  },
  toHex: function(e) {
    return Ue(this._r, this._g, this._b, e);
  },
  toHexString: function(e) {
    return "#" + this.toHex(e);
  },
  toHex8: function(e) {
    return _o(this._r, this._g, this._b, this._a, e);
  },
  toHex8String: function(e) {
    return "#" + this.toHex8(e);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(S(this._r, 255) * 100) + "%",
      g: Math.round(S(this._g, 255) * 100) + "%",
      b: Math.round(S(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(S(this._r, 255) * 100) + "%, " + Math.round(S(this._g, 255) * 100) + "%, " + Math.round(S(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(S(this._r, 255) * 100) + "%, " + Math.round(S(this._g, 255) * 100) + "%, " + Math.round(S(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : Oo[Ue(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(e) {
    var t = "#" + qe(this._r, this._g, this._b, this._a), n = t, o = this._gradientType ? "GradientType = 1, " : "";
    if (e) {
      var i = g(e);
      n = "#" + qe(i._r, i._g, i._b, i._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + o + "startColorstr=" + t + ",endColorstr=" + n + ")";
  },
  toString: function(e) {
    var t = !!e;
    e = e || this._format;
    var n = !1, o = this._a < 1 && this._a >= 0, i = !t && o && (e === "hex" || e === "hex6" || e === "hex3" || e === "hex4" || e === "hex8" || e === "name");
    return i ? e === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (n = this.toRgbString()), e === "prgb" && (n = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (n = this.toHexString()), e === "hex3" && (n = this.toHexString(!0)), e === "hex4" && (n = this.toHex8String(!0)), e === "hex8" && (n = this.toHex8String()), e === "name" && (n = this.toName()), e === "hsl" && (n = this.toHslString()), e === "hsv" && (n = this.toHsvString()), n || this.toHexString());
  },
  clone: function() {
    return g(this.toString());
  },
  _applyModification: function(e, t) {
    var n = e.apply(null, [this].concat([].slice.call(t)));
    return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
  },
  lighten: function() {
    return this._applyModification(Ao, arguments);
  },
  brighten: function() {
    return this._applyModification(Co, arguments);
  },
  darken: function() {
    return this._applyModification(Mo, arguments);
  },
  desaturate: function() {
    return this._applyModification(So, arguments);
  },
  saturate: function() {
    return this._applyModification(ko, arguments);
  },
  greyscale: function() {
    return this._applyModification(xo, arguments);
  },
  spin: function() {
    return this._applyModification($o, arguments);
  },
  _applyCombination: function(e, t) {
    return e.apply(null, [this].concat([].slice.call(t)));
  },
  analogous: function() {
    return this._applyCombination(To, arguments);
  },
  complement: function() {
    return this._applyCombination(Ro, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(jo, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(Lo, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(Ge, [3]);
  },
  tetrad: function() {
    return this._applyCombination(Ge, [4]);
  }
};
g.fromRatio = function(e, t) {
  if (he(e) == "object") {
    var n = {};
    for (var o in e)
      e.hasOwnProperty(o) && (o === "a" ? n[o] = e[o] : n[o] = Z(e[o]));
    e = n;
  }
  return g(e, t);
};
function mo(e) {
  var t = {
    r: 0,
    g: 0,
    b: 0
  }, n = 1, o = null, i = null, r = null, a = !1, s = !1;
  return typeof e == "string" && (e = No(e)), he(e) == "object" && (F(e.r) && F(e.g) && F(e.b) ? (t = bo(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : F(e.h) && F(e.s) && F(e.v) ? (o = Z(e.s), i = Z(e.v), t = wo(e.h, o, i), a = !0, s = "hsv") : F(e.h) && F(e.s) && F(e.l) && (o = Z(e.s), r = Z(e.l), t = yo(e.h, o, r), a = !0, s = "hsl"), e.hasOwnProperty("a") && (n = e.a)), n = Zt(n), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
function bo(e, t, n) {
  return {
    r: S(e, 255) * 255,
    g: S(t, 255) * 255,
    b: S(n, 255) * 255
  };
}
function Ve(e, t, n) {
  e = S(e, 255), t = S(t, 255), n = S(n, 255);
  var o = Math.max(e, t, n), i = Math.min(e, t, n), r, a, s = (o + i) / 2;
  if (o == i)
    r = a = 0;
  else {
    var l = o - i;
    switch (a = s > 0.5 ? l / (2 - o - i) : l / (o + i), o) {
      case e:
        r = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        r = (n - e) / l + 2;
        break;
      case n:
        r = (e - t) / l + 4;
        break;
    }
    r /= 6;
  }
  return {
    h: r,
    s: a,
    l: s
  };
}
function yo(e, t, n) {
  var o, i, r;
  e = S(e, 360), t = S(t, 100), n = S(n, 100);
  function a(f, c, u) {
    return u < 0 && (u += 1), u > 1 && (u -= 1), u < 1 / 6 ? f + (c - f) * 6 * u : u < 1 / 2 ? c : u < 2 / 3 ? f + (c - f) * (2 / 3 - u) * 6 : f;
  }
  if (t === 0)
    o = i = r = n;
  else {
    var s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    o = a(l, s, e + 1 / 3), i = a(l, s, e), r = a(l, s, e - 1 / 3);
  }
  return {
    r: o * 255,
    g: i * 255,
    b: r * 255
  };
}
function We(e, t, n) {
  e = S(e, 255), t = S(t, 255), n = S(n, 255);
  var o = Math.max(e, t, n), i = Math.min(e, t, n), r, a, s = o, l = o - i;
  if (a = o === 0 ? 0 : l / o, o == i)
    r = 0;
  else {
    switch (o) {
      case e:
        r = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        r = (n - e) / l + 2;
        break;
      case n:
        r = (e - t) / l + 4;
        break;
    }
    r /= 6;
  }
  return {
    h: r,
    s: a,
    v: s
  };
}
function wo(e, t, n) {
  e = S(e, 360) * 6, t = S(t, 100), n = S(n, 100);
  var o = Math.floor(e), i = e - o, r = n * (1 - t), a = n * (1 - i * t), s = n * (1 - (1 - i) * t), l = o % 6, f = [n, a, r, r, s, n][l], c = [s, n, n, a, r, r][l], u = [r, r, s, n, n, a][l];
  return {
    r: f * 255,
    g: c * 255,
    b: u * 255
  };
}
function Ue(e, t, n, o) {
  var i = [T(Math.round(e).toString(16)), T(Math.round(t).toString(16)), T(Math.round(n).toString(16))];
  return o && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function _o(e, t, n, o, i) {
  var r = [T(Math.round(e).toString(16)), T(Math.round(t).toString(16)), T(Math.round(n).toString(16)), T(Jt(o))];
  return i && r[0].charAt(0) == r[0].charAt(1) && r[1].charAt(0) == r[1].charAt(1) && r[2].charAt(0) == r[2].charAt(1) && r[3].charAt(0) == r[3].charAt(1) ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0) + r[3].charAt(0) : r.join("");
}
function qe(e, t, n, o) {
  var i = [T(Jt(o)), T(Math.round(e).toString(16)), T(Math.round(t).toString(16)), T(Math.round(n).toString(16))];
  return i.join("");
}
g.equals = function(e, t) {
  return !e || !t ? !1 : g(e).toRgbString() == g(t).toRgbString();
};
g.random = function() {
  return g.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function So(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = g(e).toHsl();
  return n.s -= t / 100, n.s = we(n.s), g(n);
}
function ko(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = g(e).toHsl();
  return n.s += t / 100, n.s = we(n.s), g(n);
}
function xo(e) {
  return g(e).desaturate(100);
}
function Ao(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = g(e).toHsl();
  return n.l += t / 100, n.l = we(n.l), g(n);
}
function Co(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = g(e).toRgb();
  return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), g(n);
}
function Mo(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = g(e).toHsl();
  return n.l -= t / 100, n.l = we(n.l), g(n);
}
function $o(e, t) {
  var n = g(e).toHsl(), o = (n.h + t) % 360;
  return n.h = o < 0 ? 360 + o : o, g(n);
}
function Ro(e) {
  var t = g(e).toHsl();
  return t.h = (t.h + 180) % 360, g(t);
}
function Ge(e, t) {
  if (isNaN(t) || t <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var n = g(e).toHsl(), o = [g(e)], i = 360 / t, r = 1; r < t; r++)
    o.push(g({
      h: (n.h + r * i) % 360,
      s: n.s,
      l: n.l
    }));
  return o;
}
function Lo(e) {
  var t = g(e).toHsl(), n = t.h;
  return [g(e), g({
    h: (n + 72) % 360,
    s: t.s,
    l: t.l
  }), g({
    h: (n + 216) % 360,
    s: t.s,
    l: t.l
  })];
}
function To(e, t, n) {
  t = t || 6, n = n || 30;
  var o = g(e).toHsl(), i = 360 / n, r = [g(e)];
  for (o.h = (o.h - (i * t >> 1) + 720) % 360; --t; )
    o.h = (o.h + i) % 360, r.push(g(o));
  return r;
}
function jo(e, t) {
  t = t || 6;
  for (var n = g(e).toHsv(), o = n.h, i = n.s, r = n.v, a = [], s = 1 / t; t--; )
    a.push(g({
      h: o,
      s: i,
      v: r
    })), r = (r + s) % 1;
  return a;
}
g.mix = function(e, t, n) {
  n = n === 0 ? 0 : n || 50;
  var o = g(e).toRgb(), i = g(t).toRgb(), r = n / 100, a = {
    r: (i.r - o.r) * r + o.r,
    g: (i.g - o.g) * r + o.g,
    b: (i.b - o.b) * r + o.b,
    a: (i.a - o.a) * r + o.a
  };
  return g(a);
};
g.readability = function(e, t) {
  var n = g(e), o = g(t);
  return (Math.max(n.getLuminance(), o.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), o.getLuminance()) + 0.05);
};
g.isReadable = function(e, t, n) {
  var o = g.readability(e, t), i, r;
  switch (r = !1, i = Po(n), i.level + i.size) {
    case "AAsmall":
    case "AAAlarge":
      r = o >= 4.5;
      break;
    case "AAlarge":
      r = o >= 3;
      break;
    case "AAAsmall":
      r = o >= 7;
      break;
  }
  return r;
};
g.mostReadable = function(e, t, n) {
  var o = null, i = 0, r, a, s, l;
  n = n || {}, a = n.includeFallbackColors, s = n.level, l = n.size;
  for (var f = 0; f < t.length; f++)
    r = g.readability(e, t[f]), r > i && (i = r, o = g(t[f]));
  return g.isReadable(e, o, {
    level: s,
    size: l
  }) || !a ? o : (n.includeFallbackColors = !1, g.mostReadable(e, ["#fff", "#000"], n));
};
var Me = g.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, Oo = g.hexNames = Eo(Me);
function Eo(e) {
  var t = {};
  for (var n in e)
    e.hasOwnProperty(n) && (t[e[n]] = n);
  return t;
}
function Zt(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function S(e, t) {
  Fo(e) && (e = "100%");
  var n = Io(e);
  return e = Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function we(e) {
  return Math.min(1, Math.max(0, e));
}
function C(e) {
  return parseInt(e, 16);
}
function Fo(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function Io(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function T(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function Z(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function Jt(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function Ke(e) {
  return C(e) / 255;
}
var L = function() {
  var e = "[-\\+]?\\d+%?", t = "[-\\+]?\\d*\\.\\d+%?", n = "(?:" + t + ")|(?:" + e + ")", o = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?", i = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(n),
    rgb: new RegExp("rgb" + o),
    rgba: new RegExp("rgba" + i),
    hsl: new RegExp("hsl" + o),
    hsla: new RegExp("hsla" + i),
    hsv: new RegExp("hsv" + o),
    hsva: new RegExp("hsva" + i),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function F(e) {
  return !!L.CSS_UNIT.exec(e);
}
function No(e) {
  e = e.replace(po, "").replace(vo, "").toLowerCase();
  var t = !1;
  if (Me[e])
    e = Me[e], t = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var n;
  return (n = L.rgb.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3]
  } : (n = L.rgba.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3],
    a: n[4]
  } : (n = L.hsl.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3]
  } : (n = L.hsla.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3],
    a: n[4]
  } : (n = L.hsv.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3]
  } : (n = L.hsva.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3],
    a: n[4]
  } : (n = L.hex8.exec(e)) ? {
    r: C(n[1]),
    g: C(n[2]),
    b: C(n[3]),
    a: Ke(n[4]),
    format: t ? "name" : "hex8"
  } : (n = L.hex6.exec(e)) ? {
    r: C(n[1]),
    g: C(n[2]),
    b: C(n[3]),
    format: t ? "name" : "hex"
  } : (n = L.hex4.exec(e)) ? {
    r: C(n[1] + "" + n[1]),
    g: C(n[2] + "" + n[2]),
    b: C(n[3] + "" + n[3]),
    a: Ke(n[4] + "" + n[4]),
    format: t ? "name" : "hex8"
  } : (n = L.hex3.exec(e)) ? {
    r: C(n[1] + "" + n[1]),
    g: C(n[2] + "" + n[2]),
    b: C(n[3] + "" + n[3]),
    format: t ? "name" : "hex"
  } : !1;
}
function Po(e) {
  var t, n;
  return e = e || {
    level: "AA",
    size: "small"
  }, t = (e.level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), n !== "small" && n !== "large" && (n = "small"), {
    level: t,
    size: n
  };
}
function M(e) {
  const t = g(e), n = () => t.getLuminance() <= 0.5;
  return {
    isDark: n,
    isLight: () => !n(),
    darken: (o) => t.darken(o).toString(),
    lighten: (o) => t.lighten(o).toString(),
    setAlpha: (o) => t.setAlpha(o).toString(),
    getLuminance: () => t.getLuminance(),
    wash: () => {
      const o = Math.min(
        (1 - t.getLuminance()) / 3,
        0.1
      );
      return t.setAlpha(o).toString();
    },
    dim: () => {
      const o = t.getLuminance(), i = o > 0.85 ? o : 0.24;
      return g("#fff").setAlpha(i).toString();
    },
    toHexString: () => t.toHexString(),
    isValid: () => t.isValid(),
    isReadable: (o) => g.isReadable(e, o, {
      level: "AA",
      size: "small"
    })
  };
}
const en = "#000000", Qe = "#ffffff";
function Ee(e) {
  return e === "auto";
}
function K(e, t) {
  return !e || Ee(e) ? t : e;
}
function Q(e) {
  return !e || M(e).isReadable(Qe) ? Qe : en;
}
function Bo(e) {
  let t = e;
  for (; M(t).isLight(); )
    t = M(t).darken(1);
  return t;
}
function le(e) {
  return M(e).getLuminance() < 0.1 ? M(e).lighten(5) : M(e).darken(5);
}
function Y(e) {
  return !e || Ee(e) || !M(e).isValid() ? "auto" : M(e).toHexString();
}
function Ho(e) {
  return e ? e.endsWith("px") ? e : `${e}px` : "0";
}
function zo(e) {
  var t, n, o, i, r, a, s, l;
  return {
    mainColor: Y((t = e.basics) == null ? void 0 : t.mainColor),
    actionColor: Y((n = e.extra) == null ? void 0 : n.actionColor),
    backgroundColor: Y((o = e.extra) == null ? void 0 : o.backgroundColor),
    borderColor: Y((i = e.extra) == null ? void 0 : i.borderColor),
    fontColor: Y((r = e.extra) == null ? void 0 : r.fontColor),
    backgroundHighlight: (a = e.extra) != null && a.backgroundHighlight ? e.extra.backgroundHighlight === "1" : !0,
    border: ((s = e.extra) == null ? void 0 : s.border) === "1",
    borderRadius: (l = e.extra) != null && l.borderRadius ? Ho(e.extra.borderRadius) : "4px"
  };
}
function Do(e) {
  const t = zo(e), n = M(t.mainColor).toHexString(), o = Bo(
    K(
      t.actionColor,
      t.mainColor
    )
  ), i = K(
    t.backgroundColor,
    t.mainColor
  ), r = K(
    t.actionColor,
    Q(i)
  );
  return {
    mainColor: {
      base: n,
      over: le(n),
      contrasted: Q(n)
    },
    fontColor: K(t.fontColor, en),
    actionColor: {
      base: o,
      washed: M(o).wash(),
      over: le(o),
      contrasted: Q(o)
    },
    actionContrastColor: {
      base: r,
      over: le(r),
      contrasted: Ee(t.actionColor) ? i : Q(r)
    },
    backgroundColor: {
      base: i,
      over: le(i),
      washed: M(i).wash(),
      dimmed: M(i).dim(),
      contrasted: Q(i)
    },
    backgroundHighlight: t.backgroundHighlight,
    border: t.border,
    borderColor: K(
      t.borderColor,
      t.mainColor
    ),
    borderRadius: t.borderRadius
  };
}
function Vo(e) {
  if (!e)
    throw new Error("Theme is required");
  Dt(
    Ut,
    Do(e)
  );
}
const W = ({
  langCode: e,
  mapper: t,
  number: n,
  keysLength: o
}) => {
  if (n === 0) return 0;
  const i = new Intl.PluralRules(e).select(n), r = t[i];
  return Math.min(
    o <= Object.keys(t).length ? r - 1 : r,
    o - 1
  );
}, Wo = (e, t) => W({
  langCode: "en-EN",
  mapper: { one: 1, other: 2 },
  number: e,
  keysLength: t
}), Uo = (e, t) => {
  const n = new Intl.PluralRules("ar-EG").select(e), o = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
  }[n];
  return Math.min(o, t - 1);
}, ke = (e, t) => W({
  langCode: "ru-RU",
  mapper: { one: 1, few: 2, many: 3 },
  number: e,
  keysLength: t
}), qo = (e, t) => W({
  langCode: "ro-RO",
  mapper: { one: 1, few: 2, other: 3 },
  number: e,
  keysLength: t
}), Go = (e, t) => W({
  langCode: "pl-PL",
  mapper: { one: 1, few: 2, many: 3 },
  number: e,
  keysLength: t
}), Ko = (e, t) => W({
  langCode: "is-IS",
  mapper: { one: 1, other: 2 },
  number: e,
  keysLength: t
}), Qo = (e, t) => W({
  langCode: "hr-HR",
  mapper: { one: 1, few: 2, other: 3 },
  number: e,
  keysLength: t
}), Yo = (e, t) => W({
  langCode: "cs-CZ",
  mapper: { one: 1, few: 2, other: 3 },
  number: e,
  keysLength: t
}), z = () => 0, Xo = {
  ar: Uo,
  cs: Yo,
  hr: Qo,
  id: z,
  is: Ko,
  ja: z,
  ko: z,
  lt: ke,
  pl: Go,
  ro: qo,
  ru: ke,
  uk: ke,
  th: z,
  vi: z,
  zh: z,
  "zh-TW": z
}, Zo = "en";
function Jo({ locale: e, messages: t, pluralRules: n }) {
  (!_(e) || !_(t)) && console.warn("i18n required locale and messages");
  const o = k(
    () => _(t)[_(e) || Zo] || {}
  ), i = (a, s) => xe(o.value[a] || a, s) || a, r = {
    t: i,
    tc: (a, s, l) => {
      var f;
      const c = (o.value[a] || a).split("|").map((d) => d.trim()), u = ((f = _(n)) == null ? void 0 : f[_(e)]) ?? Wo;
      return i(
        c[u(s, c.length)] ?? c[0],
        l
      );
    }
  };
  return Dt(qt, r), r;
}
const er = /* @__PURE__ */ V({
  __name: "SetupProvider",
  props: {
    config: {}
  },
  setup(e) {
    const t = e;
    return Vo(t.config.payload.deviceStyleConfig), Jo({
      locale: k(() => t.config.i18n.locale),
      messages: k(() => t.config.i18n.messages),
      pluralRules: k(() => t.config.i18n.pluralRules)
    }), (n, o) => me(n.$slots, "default");
  }
}), tr = /* @__PURE__ */ V({
  __name: "FloatingWindow",
  props: {
    mode: { default: "window" },
    shadowMode: { default: "standard" },
    position: { default: "bottom" }
  },
  setup(e) {
    ve((o) => ({
      "7a6b1627": _(n).borderRadius,
      "3cf47f2e": _(n).borderColor
    }));
    const t = e, n = je();
    return (o, i) => (I(), ee("div", {
      class: zt([
        "floating-window",
        `floating-window--${t.mode}`,
        `floating-window--${t.position}`,
        `floating-window--shadow-${t.shadowMode}`,
        { "floating-window--bordered": _(n).border }
      ])
    }, [
      me(o.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), nr = /* @__PURE__ */ Oe(tr, [["__scopeId", "data-v-c18fbfc1"]]);
function Fe(e) {
  return e.getRootNode() instanceof ShadowRoot;
}
function or(e) {
  return Fe(e) ? e.getRootNode().host : null;
}
function rr(e) {
  return Fe(e) ? e.getRootNode() : document;
}
const ir = {
  id: "modal-content",
  class: "thn-widget-modal__content"
}, ar = {
  key: 0,
  class: "thn-widget-modal__close"
}, sr = /* @__PURE__ */ V({
  inheritAttrs: !1,
  __name: "Modal",
  props: {
    showClose: { type: Boolean, default: !0 },
    zIndex: { default: 50 },
    focusQuery: { default: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])' }
  },
  emits: [
    "close"
  ],
  setup(e, { emit: t }) {
    ve((c) => ({
      "045c0471": n.zIndex,
      "7ca6d95e": _(a).borderRadius
    }));
    const n = e, o = t, i = Ne("rootEl"), r = Ne("modalWindow"), a = je();
    function s() {
      o("close");
    }
    async function l() {
      if (await $e(), !r.value || !n.focusQuery)
        return;
      const c = r.value.$el.querySelector(
        n.focusQuery
      );
      c ? c.focus() : r.value.$el.focus();
    }
    function f() {
      return !r.value || !n.focusQuery ? [] : Array.from(
        r.value.$el.querySelectorAll(n.focusQuery)
      ).filter((c) => !c.disabled && !c.getAttribute("aria-hidden"));
    }
    return De("Escape", () => {
      s();
    }, { target: i }), De("Tab", (c) => {
      if (!i.value) return;
      const u = rr(i.value), d = f();
      if (d.length === 0) return;
      const h = d[0], p = d[d.length - 1];
      (!c.shiftKey && u.activeElement === p || c.shiftKey && u.activeElement === h) && (c.preventDefault(), (c.shiftKey ? p : h).focus());
    }, { target: i }), (c, u) => (I(), ee("div", {
      ref_key: "rootEl",
      ref: i,
      class: "thn-widget-modal",
      tabindex: "-1",
      onClick: Ht(s, ["self"])
    }, [
      J(rn, {
        name: "slide-up",
        onAfterEnter: l,
        appear: ""
      }, {
        default: de(() => [
          J(nr, an({
            ref_key: "modalWindow",
            ref: r
          }, c.$attrs, {
            class: [
              "thn-widget-modal__window",
              c.$attrs.class
            ],
            tabindex: "0",
            role: "dialog",
            "aria-labelledby": "modal-content",
            "aria-modal": "true"
          }), {
            default: de(() => [
              sn("div", ir, [
                me(c.$slots, "default", { close: s }, void 0, !0)
              ]),
              n.showClose ? (I(), ee("div", ar, [
                J(no, {
                  type: "close",
                  "over-color": _(a).backgroundColor.base,
                  onActionClick: s,
                  "data-testid": "close-modal"
                }, null, 8, ["over-color"])
              ])) : ln("", !0)
            ]),
            _: 3
          }, 16, ["class"])
        ]),
        _: 3
      })
    ], 512));
  }
}), Hr = /* @__PURE__ */ Oe(sr, [["__scopeId", "data-v-b60562a1"]]);
var Ye;
(function(e) {
  e.ApplyDiscount = "apply-discount", e.Dismiss = "dismiss", e.Engage = "engage", e.Hide = "hide", e.NoAction = "no-action", e.Fallback = "none", e.GenericLinkClick = "generic-link-click", e.LoadScript = "load-script", e.OpenBookingEngine = "open-be", e.OpenUri = "open-uri", e.PredictiveAudience = "predictive-audience", e.SendForm = "send-form", e.SendSaveSearch = "send-save-search", e.SendSiteContact = "send-site-contact", e.SendSubscribe = "send-subscribe", e.Show = "show", e.Login = "login", e.TranslateDocumentBody = "translate-document-body";
})(Ye || (Ye = {}));
var Xe;
(function(e) {
  e.Resend = "resend", e.Signup = "signup", e.Signin = "signin", e.Validation = "validation";
})(Xe || (Xe = {}));
var v;
(function(e) {
  e.Arabic = "ar", e.Basque = "eu", e.Bulgarian = "bg", e.Catalan = "ca", e.Chinese = "zh", e.ChineseTraditional = "zh-TW", e.Croatian = "hr", e.Czech = "cs", e.Danish = "da", e.Deutsch = "de", e.Dutch = "nl", e.English = "en", e.Estonian = "et", e.Finnish = "fi", e.French = "fr", e.Greek = "el", e.Hebrew = "he", e.Hungarian = "hu", e.Icelandic = "is", e.Indonesian = "id", e.Italian = "it", e.Japanese = "ja", e.Korean = "ko", e.Lithuanian = "lt", e.Norwegian = "no", e.Polish = "pl", e.Portuguese = "pt", e.Romanian = "ro", e.Russian = "ru", e.Slovenian = "sl", e.Spanish = "es", e.Swedish = "sv", e.Thai = "th", e.Turkish = "tr", e.Ukrainian = "uk", e.Vietnamese = "vi";
})(v || (v = {}));
var Ze;
(function(e) {
  e.Timing = "timing", e.Oraculo = "oraculo", e.VisitorProfile = "visitorProfile", e.VisitorBehaviour = "visitorBehaviour", e.Search = "search", e.TravelParty = "travelParty", e.DataVariables = "dataVariables", e.Demand = "demand", e.Integrations = "integrations";
})(Ze || (Ze = {}));
var Je;
(function(e) {
  e.Exclude = "exclude", e.Include = "include";
})(Je || (Je = {}));
var et;
(function(e) {
  e.Any = "any", e.Is = "is", e.Are = "are", e.IsBetween = "isBetween", e.AreBetween = "areBetween", e.IsLower = "isLower", e.AreLower = "areLower", e.IsHigher = "isHigher", e.IsGreater = "isGreater", e.AreGreater = "areGreater", e.IsBefore = "isBefore", e.AreBefore = "areBefore", e.IsAfter = "isAfter", e.AreAfter = "areAfter", e.Contain = "contain";
})(et || (et = {}));
var tt;
(function(e) {
  e.Is = "is", e.IsNot = "isNot", e.AnyValue = "anyValue", e.NotAnyValue = "notAnyValue", e.Lower = "lower", e.Greater = "greater", e.Contains = "contains", e.NotContains = "notContains";
})(tt || (tt = {}));
var nt;
(function(e) {
  e.Registered = "registered", e.NonRegistered = "non_registered", e.RegisteredAndLogged = "registered", e.NotRegisteredAndNotLogged = "non_registered_nor_logged", e.RegisteredOrLogged = "registered_all", e.RegisteredAndNotLogged = "registered_non_logged", e.NotLogged = "non_registered";
})(nt || (nt = {}));
var ot;
(function(e) {
  e.Logged = "logged", e.NonLogged = "nonLogged";
})(ot || (ot = {}));
var rt;
(function(e) {
  e.Any = "any", e.First = "first", e.All = "all", e.Search = "search", e.Booked = "booked", e.Custom = "custom";
})(rt || (rt = {}));
var it;
(function(e) {
  e.Colors = "colors", e.Fonts = "fonts", e.Button = "button", e.SecondaryButton = "secondaryButton", e.Background = "background", e.Overlay = "overlay";
})(it || (it = {}));
var at;
(function(e) {
  e.None = "none", e.Uppercase = "uppercase", e.Lowercase = "lowercase", e.Titlecase = "titlecase";
})(at || (at = {}));
var st;
(function(e) {
  e.Google = "google", e.File = "file", e.Regular = "regular";
})(st || (st = {}));
var lt;
(function(e) {
  e.Custom = "custom", e.Square = "square", e.Medium = "medium", e.Rounded = "rounded";
})(lt || (lt = {}));
var ut;
(function(e) {
  e.Percentage = "%", e.Pixels = "px", e.Rem = "rem", e.Em = "em";
})(ut || (ut = {}));
var ct;
(function(e) {
  e.Solid = "solid", e.Outline = "outline";
})(ct || (ct = {}));
var dt;
(function(e) {
  e.Url = "url", e.DefaultText = "default_text", e.CustomText = "custom_text", e.NotLinked = "not_linked", e.CustomUrl = "custom_url";
})(dt || (dt = {}));
var N;
(function(e) {
  e.NowViewing = "nowViewing", e.TodayViewed = "todayViewed", e.BookedToday = "bookedToday", e.LastReservation = "lastReservation", e.DiscountToday = "discountToday", e.TodaySpecialOffer = "todaySpecialOffer";
})(N || (N = {}));
var ft;
(function(e) {
  e.ApplyPromoCode = "apply_promo_code", e.OpenUrl = "open_url", e.OpenMailClient = "open_mail_client", e.CallPhoneNumber = "call_phone_number", e.CloseTool = "close_tool", e.EmailCapture = "email_capture", e.SavedSearch = "saved_search", e.GoMainStep = "go_main_step", e.SendForm = "form", e.OpenBookingEngine = "send_to_be", e.Submit = "submit", e.LastSearch = "send_to_last_search";
})(ft || (ft = {}));
var ht;
(function(e) {
  e.Default = "default", e.Coupon = "coupon", e.Rate = "rate", e.Corporative = "corpo", e.Group = "group";
})(ht || (ht = {}));
var gt;
(function(e) {
  e.Primary = "primary", e.Secondary = "secondary";
})(gt || (gt = {}));
var pt;
(function(e) {
  e.Note = "note", e.Layer = "layer", e.Exit = "exit", e.Inliner = "inliner";
})(pt || (pt = {}));
var vt;
(function(e) {
  e.Success = "success", e.Failure = "failure", e.Main = "main";
})(vt || (vt = {}));
var mt;
(function(e) {
  e.LoginSignin = "login-signin", e.LoginRegister = "login-register", e.LoginSuccess = "login-success";
})(mt || (mt = {}));
var bt;
(function(e) {
  e.Activity = "activity", e.Button = "button", e.Countdown = "countdown", e.EmailCapture = "emailCapture", e.Form = "form", e.Heading = "heading", e.ImageWithBehaviour = "imageWithBehaviour", e.Icon = "icon", e.Paragraph = "paragraph", e.Perks = "perks", e.SavedSearch = "savedSearch", e.Spacer = "spacer", e.Login = "login";
})(bt || (bt = {}));
var D;
(function(e) {
  e.None = "none", e.WebExclusive = "web_exclusive", e.SubjectToAvailibity = "subject_to_availability", e.OnlyForSpecificRates = "only_for_specific_rates", e.OnlyForRegisterdUsers = "only_for_registered_users";
})(D || (D = {}));
var yt;
(function(e) {
  e.Bullets = "bullets", e.Highlights = "highlights";
})(yt || (yt = {}));
var wt;
(function(e) {
  e.None = "none", e.Solid = "solid", e.Outline = "outline";
})(wt || (wt = {}));
var _t;
(function(e) {
  e.Normal = "normal", e.Compact = "compact";
})(_t || (_t = {}));
var St;
(function(e) {
  e.Date = "date", e.Time = "time";
})(St || (St = {}));
var kt;
(function(e) {
  e.Visitor = "visitor", e.Hotel = "hotel";
})(kt || (kt = {}));
var xt;
(function(e) {
  e.Out = "out", e.Inside = "inside";
})(xt || (xt = {}));
var At;
(function(e) {
  e.Single = "single", e.Multiple = "multiple";
})(At || (At = {}));
var Ct;
(function(e) {
  e.ShortText = "shortText", e.Email = "email", e.Phone = "phone", e.Date = "date", e.LongText = "longText", e.DropDown = "dropdown", e.Selection = "selection";
})(Ct || (Ct = {}));
var Mt;
(function(e) {
  e.Top = "T", e.Bottom = "B", e.Left = "L", e.Right = "R", e.UpperLeft = "UL", e.UpperRight = "UR", e.UpperMidLeft = "UML", e.UpperMidRight = "UMR", e.LowerMidLeft = "LML", e.LowerMidRight = "LMR", e.LowerLeft = "LL", e.LowerRight = "LR";
})(Mt || (Mt = {}));
var $t;
(function(e) {
  e.Mobile = "mobile", e.Desktop = "desktop";
})($t || ($t = {}));
var Rt;
(function(e) {
  e.EveryPage = "on_every_page", e.OncePerVisit = "once_per_visit", e.OncePerVisitor = "once_per_visitor", e.OncePerProperty = "once_per_property", e.OncePerBrand = "once_per_brand";
})(Rt || (Rt = {}));
var Lt;
(function(e) {
  e.Load = "load", e.Scroll = "scroll", e.Idle = "idle";
})(Lt || (Lt = {}));
var Tt;
(function(e) {
  e.Regular = "regular", e.Compact = "compact";
})(Tt || (Tt = {}));
var jt;
(function(e) {
  e.Single = "single", e.Multi = "multi";
})(jt || (jt = {}));
var Ot;
(function(e) {
  e.Bar = "bar", e.Circular = "circular", e.CustomImage = "custom-image", e.Fullscreen = "full-screen", e.FullscreenMini = "full-screen-mini", e.LowerNotification = "lower-notification", e.NotificationTab = "notification-tab", e.Sidebar = "sidebar", e.SideGradient = "side-gradient", e.SlideIn = "slide-in", e.Square = "square", e.SquareImage = "square-image", e.Sticky = "sticky", e.StickyImage = "sticky-image";
})(Ot || (Ot = {}));
var Et;
(function(e) {
  e.Left = "left", e.Center = "center", e.Right = "right";
})(Et || (Et = {}));
var Ft;
(function(e) {
  e.Inline = "inline", e.Overlay = "overlay";
})(Ft || (Ft = {}));
N.NowViewing + "", N.TodayViewed + "", N.BookedToday + "", N.LastReservation + "", N.DiscountToday + "", N.TodaySpecialOffer + "";
D.None + "", D.SubjectToAvailibity + "", D.WebExclusive + "", D.OnlyForRegisterdUsers + "", D.OnlyForSpecificRates + "";
function zr(e) {
  return {
    [v.Arabic]: "العربية",
    [v.Basque]: "Euskara",
    [v.Bulgarian]: "Български",
    [v.Catalan]: "Català",
    [v.Chinese]: "简体中文",
    [v.ChineseTraditional]: "繁體中文",
    [v.Croatian]: "Hrvatski",
    [v.Czech]: "Čeština",
    [v.Danish]: "Dansk",
    [v.Deutsch]: "Deutsch",
    [v.Dutch]: "Nederlands",
    [v.English]: "English",
    [v.Estonian]: "Eesti",
    [v.Finnish]: "Suomi",
    [v.French]: "Français",
    [v.Greek]: "Ελληνικά",
    [v.Hebrew]: "עברית",
    [v.Hungarian]: "Magyar",
    [v.Icelandic]: "Íslenska",
    [v.Indonesian]: "Indonesia",
    [v.Italian]: "Italiano",
    [v.Japanese]: "日本語",
    [v.Korean]: "한국어",
    [v.Lithuanian]: "Lietuvių",
    [v.Norwegian]: "Norsk",
    [v.Polish]: "Polski",
    [v.Portuguese]: "Português",
    [v.Romanian]: "Română",
    [v.Russian]: "Русский",
    [v.Slovenian]: "Slovenščina",
    [v.Spanish]: "Español",
    [v.Swedish]: "Svenska",
    [v.Thai]: "ไทย",
    [v.Turkish]: "Türkçe",
    [v.Ukrainian]: "Українська",
    [v.Vietnamese]: "Tiếng Việt"
  }[e] ?? "Unknown Language";
}
const Dr = /* @__PURE__ */ V({
  __name: "I18nT",
  props: {
    keypath: {},
    tag: { default: "span" }
  },
  setup(e) {
    const t = e, n = un(), o = cn(), { t: i } = Gt(), r = Object.keys(n).sort(
      (l, f) => i(t.keypath).indexOf(`{${l}}`) - i(t.keypath).indexOf(`{${f}}`)
    ), a = r.reduce(
      (l, f, c) => {
        const u = i(t.keypath), d = `{${r[c - 1]}}`, h = `{${f}}`, p = u.indexOf(d) !== -1 ? u.indexOf(d) + d.length : 0, b = u.indexOf(h);
        return l.push(
          u.slice(p, b),
          n[f]()
        ), c === r.length - 1 && l.push(
          u.slice(b + h.length)
        ), l;
      },
      []
    ), s = () => Re(
      t.tag,
      o,
      a
    );
    return (l, f) => (I(), ce(s));
  }
});
function Vr(e) {
  return e ? "rtl" : "ltr";
}
function Wr({
  enabled: e,
  delay: t,
  callback: n
}) {
  const o = setTimeout(() => {
    e && t > 0 && n();
  }, t * 1e3), i = () => clearTimeout(o);
  return dn(i), {
    clear: i
  };
}
function Ur() {
  return {
    isHoverCapable: window.matchMedia("(any-hover: hover)").matches
  };
}
function qr({ width: e, widthUnit: t }) {
  return !e || e === "auto" ? "100%" : `${e}${t || "px"}`;
}
const lr = 10, ur = 100;
function Gr(e, t) {
  const n = m(0), { lengthY: o, direction: i } = ho(
    e,
    {
      threshold: lr,
      onSwipe() {
        i.value === "down" && (n.value = o.value);
      },
      onSwipeEnd() {
        if (i.value === "down" && Math.abs(o.value) > ur) {
          t.onEnd();
          return;
        }
        n.value = 0;
      }
    }
  );
  return { distanceY: n };
}
var cr = typeof global == "object" && global && global.Object === Object && global, dr = typeof self == "object" && self && self.Object === Object && self, fr = cr || dr || Function("return this")(), ge = fr.Symbol, tn = Object.prototype, hr = tn.hasOwnProperty, gr = tn.toString, X = ge ? ge.toStringTag : void 0;
function pr(e) {
  var t = hr.call(e, X), n = e[X];
  try {
    e[X] = void 0;
    var o = !0;
  } catch {
  }
  var i = gr.call(e);
  return o && (t ? e[X] = n : delete e[X]), i;
}
var vr = Object.prototype, mr = vr.toString;
function br(e) {
  return mr.call(e);
}
var yr = "[object Null]", wr = "[object Undefined]", It = ge ? ge.toStringTag : void 0;
function _r(e) {
  return e == null ? e === void 0 ? wr : yr : It && It in Object(e) ? pr(e) : br(e);
}
function Sr(e) {
  return e != null && typeof e == "object";
}
var kr = Array.isArray, xr = "[object String]";
function Ar(e) {
  return typeof e == "string" || !kr(e) && Sr(e) && _r(e) == xr;
}
function Cr({ zIndex: e, modalRootContainer: t }) {
  return {
    zIndex: (Ar(e) ? parseInt(e, 10) : e) + 1,
    container: t ?? "body"
  };
}
function Mr(e) {
  return e.map((t) => ({
    name: t.reviewer,
    totalReviews: t.totalReviews,
    value: {
      score: t.userScore,
      max: t.maxScore
    }
  }));
}
function $r(e) {
  return {
    visible: !!e.topPercent,
    orLocName: e.orLocName,
    hotelGeoname: e.hotelGeoname,
    hotelLocation: e.hotelLocation,
    topPercentType: e.topPercentType,
    topPercent: e.topPercent,
    hotelType: e.hotelType
  };
}
const Rr = /* @__PURE__ */ V({
  __name: "ConfigProvider",
  props: {
    config: {}
  },
  setup(e) {
    const t = e, n = k(() => ({
      ...t.config,
      calculate: {
        tooltip: Cr(t.config),
        providers: Mr(t.config.payload.reviewProviders),
        rankingConfig: $r(t.config)
      }
    }));
    return (o, i) => me(o.$slots, "default", { config: n.value });
  }
}), Lr = /* @__PURE__ */ V({
  __name: "ReviewWidget",
  props: {
    config: {}
  },
  setup(e, { expose: t }) {
    ve((p) => ({
      "3368e73c": d.value
    }));
    const n = e, o = _e(
      () => import("./chunks/FloatingDesktopReview.gt0bZfGm.js")
    ), i = _e(
      () => import("./chunks/FloatingMobileReview.1y0ChFxg.js")
    ), r = _e(
      () => import("./chunks/InlineReview.DtiFfqDc.js")
    ), a = m(), s = m(), l = m({}), f = k(() => {
      switch (n.config.formatName) {
        case "box":
          return o;
        case "inliner":
          return r;
        default:
          return i;
      }
    }), c = k(() => n.config.formatName === "fixedbar" || n.config.formatName === "sidetab"), u = k(() => ({
      payload: n.config,
      i18n: {
        locale: n.config.language,
        messages: l.value,
        pluralRules: Xo
      }
    })), d = k(() => n.config.isRightAlign ? "rtl" : "ltr");
    function h() {
      var p;
      (p = s.value) != null && p.collapse && s.value.collapse();
    }
    return $(() => n.config.language, async (p) => {
      try {
        const b = await hn(/* @__PURE__ */ Object.assign({ "./locales/ar.json": () => import("./chunks/ar.7Hnj65qu.js"), "./locales/bg.json": () => import("./chunks/bg.MLDbAGV9.js"), "./locales/ca.json": () => import("./chunks/ca.qUoW9UIE.js"), "./locales/cs.json": () => import("./chunks/cs.9Hm0dOCp.js"), "./locales/da.json": () => import("./chunks/da.4tN1BMlk.js"), "./locales/de.json": () => import("./chunks/de.CCVxCvCG.js"), "./locales/el.json": () => import("./chunks/el.DYZxcLuy.js"), "./locales/en.json": () => import("./chunks/en.CE6YGZTx.js"), "./locales/es.json": () => import("./chunks/es.DKNX9Paq.js"), "./locales/et.json": () => import("./chunks/et.DAhGIV93.js"), "./locales/eu.json": () => import("./chunks/eu.zt4aUvmG.js"), "./locales/fi.json": () => import("./chunks/fi.CXfH4G8a.js"), "./locales/fr.json": () => import("./chunks/fr.DJJylh3O.js"), "./locales/he.json": () => import("./chunks/he.BgxeOOy0.js"), "./locales/hr.json": () => import("./chunks/hr.BcOvfwOc.js"), "./locales/hu.json": () => import("./chunks/hu.BClUC-sy.js"), "./locales/id.json": () => import("./chunks/id.X1sgmzSu.js"), "./locales/is.json": () => import("./chunks/is.klMQiGJ-.js"), "./locales/it.json": () => import("./chunks/it.iwCUWtsr.js"), "./locales/ja.json": () => import("./chunks/ja.CYFL8kBl.js"), "./locales/ko.json": () => import("./chunks/ko.XzkpcogN.js"), "./locales/lt.json": () => import("./chunks/lt.CyouhUGd.js"), "./locales/nl.json": () => import("./chunks/nl.DWIw2BuY.js"), "./locales/no.json": () => import("./chunks/no.CD3hiPA7.js"), "./locales/pl.json": () => import("./chunks/pl.DKSX3qtM.js"), "./locales/pt.json": () => import("./chunks/pt.3DHLfYox.js"), "./locales/ro.json": () => import("./chunks/ro.XDTHZwSn.js"), "./locales/ru.json": () => import("./chunks/ru.Cu9aXKYP.js"), "./locales/sl.json": () => import("./chunks/sl.BsRyVEqp.js"), "./locales/sv.json": () => import("./chunks/sv.DwNXf1jW.js"), "./locales/th.json": () => import("./chunks/th.COBTdJlN.js"), "./locales/tr.json": () => import("./chunks/tr.C61PpSVn.js"), "./locales/uk.json": () => import("./chunks/uk.BNQOPclh.js"), "./locales/vi.json": () => import("./chunks/vi.D2x5jJUs.js"), "./locales/zh-TW.json": () => import("./chunks/zh-TW.BFLuNnka.js"), "./locales/zh.json": () => import("./chunks/zh.BGDxLBAq.js") }), `./locales/${p}.json`, 3);
        l.value = {
          [p]: b.default
        };
      } catch {
        l.value = {}, console.warn("THN: Error loading i18n messages");
      }
    }, { immediate: !0 }), te(() => {
      c.value && (a.value && Fe(a.value) ? O(
        window,
        "click",
        (p) => {
          a.value && p.target !== or(a.value) && h();
        },
        { passive: !0 }
      ) : wn(
        s,
        h,
        {
          ignore: [".thn-widget-modal"]
        }
      ));
    }), t({
      collapse: h
    }), (p, b) => (I(), ee("div", {
      ref_key: "rootEl",
      ref: a,
      class: "thn--widget thn--widget-review root w-full"
    }, [
      J(_(er), { config: u.value }, {
        default: de(() => [
          J(Rr, {
            config: n.config
          }, {
            default: de(({ config: y }) => [
              (I(), ce(fn(f.value), {
                ref_key: "widget",
                ref: s,
                config: y
              }, null, 8, ["config"]))
            ]),
            _: 1
          }, 8, ["config"])
        ]),
        _: 1
      }, 8, ["config"])
    ], 512));
  }
}), Tr = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, Kr = /* @__PURE__ */ Tr(Lr, [["__scopeId", "data-v-2ac3d37e"]]);
export {
  Ur as C,
  Pr as D,
  Gr as E,
  Br as F,
  no as I,
  Hr as L,
  qr as N,
  Vr as R,
  Wr as X,
  De as Z,
  Tr as _,
  je as a,
  Fr as b,
  Ir as c,
  Er as d,
  Kr as default,
  zr as e,
  nr as h,
  Dr as k,
  Or as o,
  Gt as p,
  Oe as s,
  Nr as u,
  U as x
};
//# sourceMappingURL=review.es.js.map
